export const INDUSTRIES = [
    'IT services',
    'Hotels',
    'Restaurants',
    'Spa',
    'Massage',
    'Gym',
    'Nail',
    'Hair, Beauty',
    'Retail Shop',
    'Real Estate (Rental, Sale, Management)',
    'Auto (Repair, Parts, Sale)',
    'Home, Garden services',
    'Laundry',
    'Medicine, Therapy',
    'Education',
    'Industrial, Production, Construction, Design, Architecture',
    'Arts, Music, Graphic Design',
    'Travel, Entertainment',
    'Finance, Legal, Consulting',
    'Other category'
];

export enum BillingType {
    MONTHLY = 'monthly',
    ANNUAL = 'annual'
}

export enum ProfileTab {
    Account = 'account',
    Members = 'members',
    Keys = 'keys',
    Advanced = 'advanced'
}
